import { render } from "./Complaints.vue?vue&type=template&id=4adf6b43"
import script from "./Complaints.vue?vue&type=script&lang=js"
export * from "./Complaints.vue?vue&type=script&lang=js"

import "./Complaints.vue?vue&type=style&index=0&id=4adf6b43&lang=css"

import exportComponent from "D:\\CAS Project\\ESM Web App\\master ESM-WEB\\esm-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__